import React from "react";
import '../../css/footer.css';
// import ig from '../../images/igLogo.png';
// import x from '../../images/xlogo.png';
// import Youtube from "../../images/YT.png"
// import Facebook from "../../images/fb.png"
import { Link } from "react-router-dom";
import phone from "../../images/phone.png";
import email from "../../images/email.png";

export default function footer() {
    return (
        <div className='footer'>
            <h1 className="contact-us">
                Susisiekite su mumis
            </h1>
            <div className='footer-content'>
                <div className='column'>
                    <div className='contacts'>
                        <h2 className="internet inline">
                            Elektroniniu paštu
                        </h2>
                        <div className="mail inline">
                            <img className="contacts-img" src={email} alt="example"></img>
                            <p className="contacts-text">
                                <a href="mailto:finansailab@gmail.com">finansailab@gmail.com</a>
                            </p>
                        </div>
                        <p className="inline">Esame pasirengę ir norime padėti.</p>
                    </div>
                </div>
                <div className='column'>
                    <div className='contacts'>
                        <h2 className="internet inline">
                            Telefonu
                        </h2>
                        <div className="phone inline">

                            <img className="contacts-img" src={phone} alt="example"></img>
                            <p className="contacts-text">
                                +370 693 55991
                            </p>

                        </div>
                        <p className="inline">
                            Darbo dienomis: 8:00 - 17:00 val.<br />
                            Savaitgaliais: 10:00 - 15:00 val.
                        </p>
                    </div>
                </div>
                <div className='column'>
                    <div className='contacts'>
                        <h2 className="internet inline">
                            Registruokitės konsultacijai
                        </h2>
                        <Link to="/konsultacija" className="registerButton">
                            Registracija
                        </Link><br />
                        <h1 className="inline">
                            Registruokitės konsultacijai su mūsų specialistais.
                        </h1>
                    </div>
                </div>
                {/* <div className='column'>
                    <div className='socials'>
                        <h2>
                            Socialiniai tinklai
                        </h2>
                        <a href="https://l.facebook.com/l.php?u=https%3A%2F%2Finstagram.com%2Ffinansailab%3Figshid%3DZDdkNTZiNTM%253D%26fbclid%3DIwAR0-KZQ62WrEzRF0cWdjL2ABOw_5PgDsXDsRo8NAeutKG_8wqiSmlEK_MMo&h=AT1Svba55CpREg_pvGJw4BdU2kVkKV6zxFXgJYYVA0_n2j-6RZKfwL8D1kFtMGX8zF6DPZyVw0QNawcuz0uc5IfEYv47l4mnCENaXGos7jx2230eppuW12qEtcwoAVT-tv_IJg" target="_blank" rel="noreferrer">
                            <img className="footerImg" src={ig} alt="example" />
                        </a>
                        <a href="https://x.com/FinansaiL?t=8n5aoXrignp5XjJGsTePaA&s=07" target="_blank" rel="noreferrer">
                            <img className="footerImg" src={x} alt="example" />
                        </a>
                        <a href="https://www.youtube.com/@finansailab" target="_blank" rel="noreferrer">
                            <img className="footerImg" src={Youtube} alt="example" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=100076323362434" target="_blank" rel="noreferrer">
                            <img className="footerImg" src={Facebook} alt="example" />
                        </a>
                    </div>
                </div> */}
            </div>
            <div className='privacy-content'>
                <div className='privacyPolicy'>
                    <Link to="/privatumas" className="privacy">Privatumo politika</Link>
                </div>
            </div>
        </div>

    )
}